fragment links on links_MatrixField {
    ... on externalLink_Entry {
        label
        externalUrl
    }
    ... on entry_Entry {
        label
        entry {
            entryType: typeHandle
            id
            uri
            url
        }
    }
}
